import React from 'react';

import { Box } from '@chakra-ui/react';

import { AnonymousSmiley } from 'assets/assetsV1/iconComponents';

import { PEER_TYPE_TAG_NAME_MAP, REVIEW_RESPONSE_PROVIDER_TYPE_TITLE_MAP_1 } from 'constants/ProjectConstants';

// import { Avatar } from '@material-ui/core';
import { Avatar } from 'uiToolkitV1/Avatar';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';

const ResultEmployeeToggle = ({
  options = [],
  selectedOptionId = null,
  changeHandler = () => {},
  ...containerProps
}) => {
  // const [selectedOptionValue, setSelectedOptionValue] = useState(selectedOptionId);

  const onChangeHandler = (newSelectedValue) => {
    // setSelectedOptionValue(newSelectedValue);
    changeHandler(newSelectedValue);
  };

  return (
    <Box {...containerProps}>
      {options?.map((providerOption, index) => {
        const { id, displayName, providerType, profilePhotoSrc, reviewId, peerType } = providerOption;
        const isSelected = selectedOptionId === reviewId;
        const isPeerProviderType = providerType === 'PEER' && peerType !== 'ALL_ORG';
        const peerTypeDisplayName = (isPeerProviderType && PEER_TYPE_TAG_NAME_MAP[peerType]) || null;
        const subtitleText = `${REVIEW_RESPONSE_PROVIDER_TYPE_TITLE_MAP_1[providerType]} ${
          peerTypeDisplayName ? `(${peerTypeDisplayName})` : ''
        }`;
        return (
          <Box pos="relative" key={id}>
            <ListItemComp
              active={isSelected}
              key={id}
              onClick={() => onChangeHandler(providerOption)}
              title={displayName ?? 'Anonymous'}
              subTitle={subtitleText}
              LeftComponent={() => {
                if (!displayName) return <AnonymousSmiley />;
                return <Avatar src={profilePhotoSrc} name={displayName} />;
              }}
              isBoldText={isSelected}
              padding="4px 12px"
              size="regularSmall"
            />
          </Box>
        );
      })}
    </Box>
  );
};

export { ResultEmployeeToggle };
